module.exports = __webpack_public_path__ + "img/u1218.333ea3e6.svg";